import { LucideSparkles } from "lucide-react";

export function AIMessageHeader() {
  return (
    <div className="inline-flex gap-1 items-center">
      <div className="bg-primary rounded-full size-4 flex items-center justify-center">
        <LucideSparkles className="size-3 text-primary-foreground" />
      </div>
      <span className="text-sm font-medium text-muted-foreground">Babask</span>
    </div>
  );
}
